import { CrecerResultsContainer } from 'src/assets/styles/components/clase3Answers';
import { DISCResults, showSpiritualGifts } from './crecerUserAnswers';
import { countAnswers } from '../../../components/helpers';
import { sacredPath, spiritualGifts } from './surveysQuestions';
import moment from 'moment';

export const InPersonStudentResults = (props) => {
  const { spiritualGiftAnswers, DISCAnswers, experienceWithGodAnswers, student, surveyDate } =
    props;

  const displayDate = surveyDate
    ? moment(surveyDate).tz('America/Bogota').format('DD-MM-YYYY')
    : moment.tz('America/Bogota').format('DD-MM-YYYY');

  const spiritualScores = spiritualGiftAnswers ? countAnswers(spiritualGiftAnswers) : [];
  const experienceScores = experienceWithGodAnswers ? countAnswers(experienceWithGodAnswers) : [];

  return (
    <CrecerResultsContainer className="survey-results-body">
      <header className="results-meta">
        <p className="results-meta__name">
          Encuesta de{' '}
          <strong>
            {student?.name} {student?.lastName}
          </strong>
        </p>
        <div className="results-meta__row">
          <span>
            Fecha: <strong>{displayDate}</strong>
          </span>
          <span className="results-meta__org">Iglesia Comunidad</span>
        </div>
      </header>

      {!!DISCAnswers && !!Object.keys(DISCAnswers).length && DISCResults(countAnswers(DISCAnswers))}

      {!!spiritualGiftAnswers && !!Object.keys(spiritualGiftAnswers).length && (
        <section className="spiritual result-section">
          <header className="result-section__header">
            <p className="result-section__eyebrow">Dones</p>
            <h2>Los dones espirituales que Dios te ha dado</h2>
          </header>
          {[0, 1, 2, 3, 4].map((position) =>
            spiritualScores[position]
              ? showSpiritualGifts(spiritualGifts, spiritualScores, position)
              : null
          )}
        </section>
      )}

      {!!experienceWithGodAnswers && !!Object.keys(experienceWithGodAnswers).length && (
        <section className="connecting result-section">
          <header className="result-section__header">
            <p className="result-section__eyebrow">Experiencia</p>
            <h2>La forma como te conectas con Dios</h2>
          </header>
          {[0, 1, 2].map((position) =>
            experienceScores[position]
              ? showSpiritualGifts(sacredPath, experienceScores, position)
              : null
          )}
        </section>
      )}
    </CrecerResultsContainer>
  );
};
